import { StoryblokComponent, storyblokEditable } from "@storyblok/react";
import { Breadcrumb } from "./Breadcrumb";
import { FooterBuffer } from "./FooterBuffer";

const FitnessFundraising = ({ blok }) => {
  return (
    <>
      <div {...storyblokEditable(blok)} className="font-display ">
        <div className="container herosub">
          <Breadcrumb currentName={blok.title} />
          <h1>{blok.title}</h1>
          <h2>{blok.subtitle}</h2>
        </div>

        <div className="font-display text-left solution-content">
          <div className="intro-fitness">
            <h2>{blok.intro}</h2>
          </div>
          <div className="card-grid fitness">
            {blok.grid
              ? blok.grid.map((blok) => (
                  <StoryblokComponent blok={blok} key={blok._uid} />
                ))
              : null}
          </div>
        </div>
      </div>
      <FooterBuffer />
    </>
  );
};

export default FitnessFundraising;
